import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Icon from "./Icon";
import { useWindowsSize } from "../hooks";

import ThemeContext from "../utils/theme";

export default function Button({
  className = "",
  label,
  displayType = "primary",
  inverted = false,
  sticky = false,
  inline = false,
  ...restProps
}) {
  const { colorPrimary, colorInvertedPrimary, buttonStickyBreakpoint } = useContext(
    ThemeContext,
  );
  const { width } = useWindowsSize();

  const parsedStickyBreakpoint = useMemo(
    () => Number(buttonStickyBreakpoint.replace("px", "")),
    [buttonStickyBreakpoint],
  );

  const isStickyViewport = useMemo(() => width <= parsedStickyBreakpoint, [
    width,
    parsedStickyBreakpoint,
  ]);

  const buttonClassName = classnames("btn", className, {
    "btn--sticky": sticky && isStickyViewport,
    "btn--inline": inline,
    "btn-primary": displayType === "primary",
    "btn-secondary": displayType === "secondary",
    "btn-primary-inverted": displayType === "primary-inverted",
  });
  const iconColor =
    displayType === "primary-inverted"
      ? `rgb(${colorPrimary}}`
      : `rgb(${colorInvertedPrimary})`;

  const showIcon = displayType === "primary" || displayType === "primary-inverted";

  return (
    <button {...restProps} className={buttonClassName}>
      <span className="label">{label}</span>

      {showIcon ? <Icon symbol="long-right" color={iconColor} /> : null}
    </button>
  );
}

Button.propTypes = {
  displayType: PropTypes.oneOf(["primary", "secondary", "primary-inverted"]),
  label: PropTypes.string.isRequired,
  inverted: PropTypes.bool,
  className: PropTypes.string,
  sticky: PropTypes.bool,
  inline: PropTypes.bool,
};
